// extracted by mini-css-extract-plugin
module.exports = {"LoaderWrapper":"Loader_LoaderWrapper__IoL40","Show":"Loader_Show__1Xb8S","Loader":"Loader_Loader__24y45","lds-ripple":"Loader_lds-ripple__3ycjR"};